// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3N1gG","disabled":"FileBtn_disabled__20aY2","warn":"FileBtn_warn__3Ck5X","fade":"FileBtn_fade__2uLBS"};